module.exports = __webpack_public_path__ + "static/media/TikTok_Chin_Android.9c6e3297.docx";